import axios from "axios";

export function logApiError(context: string, err: unknown) {
  if (axios.isAxiosError(err)) {
    console.error(`${context} failed`, {
      status: err.response?.status,
      data: err.response?.data,
      message: err.message,
    });
  } else {
    console.error(`${context} failed`, err);
  }
}

export function getBackendMessage(err: unknown): string | undefined {
  if (!axios.isAxiosError(err)) return undefined;
  const data = err.response?.data;
  if (data && typeof data === "object" && typeof (data as { message?: unknown }).message === "string") {
    return (data as { message: string }).message;
  }
  return undefined;
}

export function getStatus(err: unknown): number | undefined {
  return axios.isAxiosError(err) ? err.response?.status : undefined;
}
